import threeDegreesLogo from "@/assets/billing/team-logos/3degrees.png";
import aquilaCapitalLogo from "@/assets/billing/team-logos/aquila-capital.svg";
import boltLogo from "@/assets/billing/team-logos/bolt.svg";
import ecohzLogo from "@/assets/billing/team-logos/ecohz.png";
import evliLogo from "@/assets/billing/team-logos/evli.svg";
import gliaLogo from "@/assets/billing/team-logos/glia.svg";
import southPoleLogo from "@/assets/billing/team-logos/south-pole.svg";
import statnettLogo from "@/assets/billing/team-logos/statnett.svg";
import trimbleLogo from "@/assets/billing/team-logos/trimble.svg";

/**
 * The logos Soldera shows as proof: soldera.org's customer strip, its "Recognised by" row and its investors, and
 * the "Previously at" row of the Soldera team sheet (bundled from the brand artifact). Each links to the company.
 *
 * @property stacked - A mark above a small wordmark, which needs more height to match its neighbours
 * @property url - The company's own site, opened in a new tab
 */
export interface MarqueeLogo {
  name: string;
  src: string;
  url: string;
  stacked?: boolean;
}

const SITE_LOGOS = "https://www.soldera.org/assets/images/customer-logos";
const MARKETING_LOGOS =
  "https://storage.googleapis.com/soldera-marketing-public";

export const CUSTOMER_LOGOS: MarqueeLogo[] = [
  {
    name: "Mars",
    url: "https://www.mars.com",
    src: `${SITE_LOGOS}/mars.webp`,
  },
  {
    name: "Ecolab",
    url: "https://www.ecolab.com",
    src: `${SITE_LOGOS}/ecolab.webp`,
  },
  {
    name: "Octopus Energy",
    url: "https://octopus.energy",
    src: `${SITE_LOGOS}/octopus-energy.webp`,
    stacked: true,
  },
  {
    name: "Savon Voima",
    url: "https://savonvoima.fi",
    src: `${SITE_LOGOS}/savon-voima.webp`,
  },
  {
    name: "Fu-Gen",
    url: "https://fu-gen.com",
    src: `${SITE_LOGOS}/fu-gen.webp`,
  },
  {
    name: "Solarigo",
    url: "https://solarigo.fi",
    src: `${SITE_LOGOS}/solarigo.webp`,
  },
];

export const TEAM_LOGOS: MarqueeLogo[] = [
  {
    name: "3Degrees",
    url: "https://3degreesinc.com",
    src: threeDegreesLogo,
  },
  {
    name: "ECOHZ",
    url: "https://www.ecohz.com",
    src: ecohzLogo,
  },
  {
    name: "South Pole",
    url: "https://www.southpole.com",
    src: southPoleLogo,
  },
  {
    name: "Aquila Capital",
    url: "https://www.aquila-capital.de",
    src: aquilaCapitalLogo,
  },
  { name: "Statnett", url: "https://www.statnett.no", src: statnettLogo },
  { name: "Evli", url: "https://www.evli.com", src: evliLogo },
  { name: "Trimble", url: "https://www.trimble.com", src: trimbleLogo },
  { name: "Bolt", url: "https://bolt.eu", src: boltLogo },
  { name: "Glia", url: "https://www.glia.com", src: gliaLogo },
];

/** Memberships and recognition, then investors. Their names sit in small type inside the logo. */
export const RECOGNISED_LOGOS: MarqueeLogo[] = [
  {
    name: "RECS Energy Certificate Association",
    url: "https://recs.org/member/soldera/",
    src: `${MARKETING_LOGOS}/Membership%26PartnerLogos/RECS_Energy_Certificate_Association_cropped.svg`,
  },
  {
    name: "Eurelectric",
    url: "https://www.eurelectric.org",
    src: `${MARKETING_LOGOS}/Membership%26PartnerLogos/Eurelectric.svg`,
  },
  {
    name: "UN Energy",
    url: "https://www.un.org/en/energy",
    src: `${MARKETING_LOGOS}/Membership%26PartnerLogos/UN_Energy_cropped.svg`,
  },
  {
    name: "Energy Compacts",
    url: "https://www.un.org/en/energycompacts",
    src: `${MARKETING_LOGOS}/Membership%26PartnerLogos/Energy_Compacts_cropped.svg`,
  },

  {
    name: "Lifeline Ventures",
    url: "https://www.lifelineventures.com",
    src: `${MARKETING_LOGOS}/LandingPageInvestorLogoScroller/LifelineVenturesLogo.svg`,
  },
  {
    name: "Skaala",
    url: "https://www.skaala.com",
    src: `${MARKETING_LOGOS}/LandingPageInvestorLogoScroller/SkaalaLogo.svg`,
  },
  {
    name: "Lemonade Stand",
    url: "https://lemonadestand.ee",
    src: `${MARKETING_LOGOS}/LandingPageInvestorLogoScroller/LemonadeStandLogo.svg`,
  },
];
